/* HZ 2026-09-14: moved out of snippets/card-product.liquid into this deferred asset file.
   Same code; it used to be inlined into every page (and, for the quick-add,
   once per product card) and blocked HTML parsing while it evaluated. */
(function() {
  if (window.__hzQuickAddInit) return;
  window.__hzQuickAddInit = true;

  /* ── Update header cart bubble count ── */
  function updateCount(cart) {
    var badges = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], cart-icon-bubble span[aria-hidden="true"]');
    badges.forEach(function(b) { b.textContent = cart.item_count; });
    var srBadges = document.querySelectorAll('.cart-count-bubble .visually-hidden');
    srBadges.forEach(function(b) { b.textContent = cart.item_count + ' items'; });
    /* Show bubble if hidden */
    var bubble = document.querySelector('.cart-count-bubble');
    if (bubble && cart.item_count > 0) bubble.classList.remove('hidden');
  }

  /* ── Try to open our custom drawer if available ── */
  function tryOpenDrawer(cart) {
    if (typeof window.hzOpenCartDrawer === 'function') {
      window.hzOpenCartDrawer(cart);
      return;
    }
    var drawer = document.querySelector('.hz-cart-drawer');
    if (drawer) {
      document.dispatchEvent(new CustomEvent('hz:cart:open', { detail: cart }));
      return;
    }
    /* Fallback: bounce the header cart icon so user sees feedback */
    var cartIcon = document.querySelector('#cart-icon-bubble, .header__icon--cart, a[href="/cart"]');
    if (cartIcon) {
      cartIcon.style.transition = 'transform 0.15s';
      cartIcon.style.transform = 'scale(1.3)';
      setTimeout(function() { cartIcon.style.transform = ''; }, 300);
    }
  }

  /* ── Mobile: detect touch device ── */
  var isTouchDevice = window.matchMedia('(hover: none)').matches;

  /* ── Mobile: collapse a size strip ── */
  function collapseStrip(strip) {
    if (!strip) return;
    strip.classList.remove('hz-size-strip--expanded');
    var trigger = strip.parentElement.querySelector('[data-hz-trigger]');
    if (trigger) trigger.classList.remove('hz-quick-trigger--hidden');
  }

  /* ── Mobile: expand a size strip ── */
  function expandStrip(strip) {
    if (!strip) return;
    /* Collapse any other open strips first */
    document.querySelectorAll('.hz-size-strip--expanded').forEach(function(s) {
      if (s !== strip) collapseStrip(s);
    });
    strip.classList.add('hz-size-strip--expanded');
    var trigger = strip.parentElement.querySelector('[data-hz-trigger]');
    if (trigger) trigger.classList.add('hz-quick-trigger--hidden');
  }

  /* ── Mobile: "+" trigger button ── */
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-hz-trigger]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    var media = trigger.closest('.card__media');
    if (!media) return;
    var strip = media.querySelector('.hz-size-strip');
    expandStrip(strip);
  });

  /* ── Mobile: "X" close button ── */
  document.addEventListener('click', function(e) {
    var closeBtn = e.target.closest('[data-hz-close]');
    if (!closeBtn) return;
    e.preventDefault();
    e.stopPropagation();
    var strip = closeBtn.closest('.hz-size-strip');
    collapseStrip(strip);
  });

  /* ── Mobile: tap outside to collapse ── */
  document.addEventListener('click', function(e) {
    if (!isTouchDevice) return;
    if (e.target.closest('.hz-size-strip') || e.target.closest('[data-hz-trigger]')) return;
    document.querySelectorAll('.hz-size-strip--expanded').forEach(function(s) {
      collapseStrip(s);
    });
  });

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-hz-quick-add]');
    if (!btn || btn.disabled || btn.dataset.hzLocked) return;

    e.preventDefault();
    e.stopPropagation();
    btn.dataset.hzLocked = 'true';

    var variantId = btn.getAttribute('data-variant-id');
    var origHTML = btn.innerHTML;
    var strip = btn.closest('.hz-size-strip');

    btn.style.pointerEvents = 'none';
    btn.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
    .then(function(r) {
      if (!r.ok) return r.json().then(function(err) { throw new Error(err.description || 'Failed'); });
      return r.json();
    })
    .then(function() {
      return fetch('/cart.js').then(function(r) { return r.json(); });
    })
    .then(function(cart) {
      updateCount(cart);
      /* Checkmark feedback */
      btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l3.5 3.5L12 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      btn.classList.add('hz-size-btn--added');
      tryOpenDrawer(cart);

      /* Collapse strip on mobile after add */
      if (isTouchDevice && strip) {
        setTimeout(function() { collapseStrip(strip); }, 800);
      }

      setTimeout(function() {
        btn.innerHTML = origHTML;
        btn.classList.remove('hz-size-btn--added');
        btn.style.pointerEvents = '';
        delete btn.dataset.hzLocked;
      }, 1200);
    })
    .catch(function() {
      btn.textContent = '!';
      setTimeout(function() {
        btn.innerHTML = origHTML;
        btn.style.pointerEvents = '';
        delete btn.dataset.hzLocked;
      }, 1500);
    });
  });

  /* ── Click on card image area → navigate to PDP ── */
  /* With card__media at z-index:5 on hover, clicks land on the image  */
  /* instead of Dawn's link overlay. Route them to the product URL.    */
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-hz-quick-add]')) return;
    if (e.target.closest('.hz-size-strip')) return;
    if (e.target.closest('[data-hz-trigger]')) return;
    if (e.target.closest('[data-hz-close]')) return;
    var media = e.target.closest('.card__media');
    if (!media) return;
    var card = media.closest('.card-wrapper') || media.closest('.card');
    if (!card) return;
    var link = card.querySelector('a[href*="/products/"]');
    if (link) window.location.href = link.href;
  });
})();
